// import { Public } from '@/http';
const login = {
    namespaced: true,
    state: {
        jwtToken: '',
        actionPermissions: ['1111']
    },
    mutations: {
        logout(state, vm) { }
    },
    actions: {
        async login({ state, dispatch, commit, getters, rootGetters }) {
            // await Public.login({});
        }
    }
};

export default login;
